import { mapState } from 'vuex'
import isShallowEqual from '@wordpress/is-shallow-equal'
import { TYPES } from '@md/users/constances'
import FilterUi from '../Ui'

export default {
  props: [
    'loading',
    'value',
    'receive',
    'all',
    'available',
    'pagination',
    'label',
    'needSearch',
    'filterKey',
  ],

  components: {
    FilterUi,
  },

  data() {
    return {
      prepared: {},
      isDefaultPeriodApplied: false,
    }
  },

  watch: {
    value: {
      immediate: true,
      handler({ filters = {} } = {}, { filters: oldFilters } = {}) {
        if (isShallowEqual(filters, oldFilters)) {
          return
        }

        this.prepare(filters)
      },
    },
    all: {
      immediate: true,
      deep: true,
      handler() {
        this.applyUsersDefaultOrdersPeriod()
      },
    },
  },

  computed: {
    ...mapState('users/auth', ['user']),

    totalCount() {
      return Object.hasOwnProperty.call(this.pagination, 'total') ? this.pagination.total : this.value.total
    },

    filters() {
      const base = (this.all && this.all.item) ? this.all.item : []

      const isUsers = this.filterKey === 'users'
      const isManager = [
        TYPES.MANAGER,
        TYPES.STORE_WH,
      ].includes(this.user?.info?.role)

      if (isUsers && isManager) {
        return base.filter(f => f?.name !== 'role')
      }

      return base
    },
  },

  created() {
    if (this.filterKey) {
      this.receive({ preset_key: this.filterKey })
    }
  },

  methods: {
    applyUsersDefaultOrdersPeriod() {
      if (this.isDefaultPeriodApplied) return
      if (this.filterKey !== 'users') return

      const base = (this.all && this.all.item) ? this.all.item : []
      if (!base.length) return

      const currentFilters = (this.value && this.value.filters) ? this.value.filters : {}

      if (currentFilters.orders_date_from || currentFilters.orders_date_to) {
        this.isDefaultPeriodApplied = true
        return
      }

      const today = new Date()
      const from = new Date(today.getFullYear(), today.getMonth(), 1)

      const fmt = (d) => {
        const y = String(d.getFullYear())
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${day}.${m}.${y}`
      }

      const next = {
        ...currentFilters,
        orders_date_from: fmt(from),
        orders_date_to: fmt(today),
      }

      this.isDefaultPeriodApplied = true
      this.handleInputFilter(next)
    },
    prepare(value) {
      const isUsers = this.filterKey === 'users'
      const isManager = this.user?.info?.role === TYPES.MANAGER

      if (isUsers && isManager && value && typeof value === 'object') {
        const copy = { ...value }
        delete copy.role
        this.prepared = copy
        return
      }

      this.prepared = value
    },

    handleInputFilter(value) {
      this.handleInput(value)
      this.filter()
    },

    handleInput(value) {
      this.prepare(value)
    },

    filter() {
      this.$emit('input', { ...this.value, filters: this.prepared, offset: 0 })
    },
  },
}
